import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filterMarkUp'})
export class FilterMarkUpPipe implements PipeTransform {
  DomParser = require('dom-parser');
  private domparser = new this.DomParser();
  transform(storyContent: string | undefined): string {
    if (storyContent == undefined) return ''
    const htmlString = storyContent;
    const domDoc = this.domparser.parseFromString(htmlString!, 'text/html')
    let storyMarkUp = htmlString!;
    // Remove Title
    if(domDoc.getElementsByTagName("h1").length > 0) {
      storyMarkUp = storyMarkUp.replace(domDoc.getElementsByTagName("h1")[0].outerHTML, '');
    }
    // Remove Subtitle(Byline)
    if(domDoc.getElementsByClassName('ck-subtitle').length > 0) {
      storyMarkUp = storyMarkUp.replace(domDoc.getElementsByClassName('ck-subtitle')[0].outerHTML, '');
    }
    return storyMarkUp
  }
}
